import { __awaiter } from "tslib";
import { callPromiseWithRetry, callWithRetry } from './utils/callWithRetry';
import { waitForChatSdkReady } from './utils/waitForChatSdkReady';
export const injectChatScriptByVersion = ({ id, version = 'v1', environment, async = false, defer = false, nonce = undefined, }, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const domain = environment === 'development' ? 'solutodev.com' : 'anywhereexpert.us';
    const src = `https://chat-sdk.remoteexpert.${domain}/remote-expert-chat-sdk-${version}.js`;
    yield injectScript({ id, src, async, defer, nonce }, callback);
});
export const injectScript = ({ id, src, async = false, defer = false, nonce, }, callback) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise(function (resolve) {
        return __awaiter(this, void 0, void 0, function* () {
            const existingScript = document.getElementById(id);
            if (!existingScript) {
                console.info('RE:SDK: injecting chat');
                const script = document.createElement('script');
                script.onload = () => __awaiter(this, void 0, void 0, function* () {
                    if (callback)
                        yield callback();
                    resolve();
                });
                script.id = id;
                script.async = async;
                script.defer = defer;
                if (nonce)
                    script.nonce = nonce;
                script.src = src;
                document.body.appendChild(script);
            }
            else {
                console.info('RE:SDK: chat already injected, waiting for ready');
                yield waitForChatSdkReady;
                if (callback)
                    yield callback();
                resolve();
            }
        });
    });
});
export const initialize = (config) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    yield callPromiseWithRetry(window.__CHAT_SDK.initialize(config));
});
export const updateMessagingTopic = (messagingTopic) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.updateConfig({ messagingTopic }));
});
export const updatePartner = (partner) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.updateConfig({ partner }));
});
export const updateLanguage = (language) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.updateConfig({ language }));
});
export const updateConfig = (config) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.updateConfig(config));
});
export const showChatBubble = () => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(window.__CHAT_SDK.showChatBubble);
});
export const hideChatBubble = () => callWithRetry(() => window.__CHAT_SDK.hideChatBubble());
export const expandChatOverlay = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.expandChatOverlay(payload));
});
export const collapseChatOverlay = () => window.__CHAT_SDK.collapseChatOverlay();
export const attachSDKToContainer = (containerElementId) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.attachSDKToContainer(containerElementId));
});
export const detachSDKFromContainer = () => {
    callWithRetry(() => window.__CHAT_SDK.detachSDKFromContainer());
};
export const sendMessage = (message, autoSend) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.showMessage(message, autoSend));
});
export const showMessage = (message, autoSend) => __awaiter(void 0, void 0, void 0, function* () {
    yield waitForChatSdkReady;
    callWithRetry(() => window.__CHAT_SDK.showMessage(message, autoSend));
});
